import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {ModalCore} from "@pg-design/modal-module";
import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {Currency} from "@pg-rp/common-types";

import {ApplicationFormRodoInfo} from "../../application/components/ApplicationFormRodoInfo";
import {ApplicationVendorInfo} from "../../application/components/ApplicationVendorInfo";
import {useShouldShowPriceByOfferConfigAndUser} from "../../hooks/use_should_show_price_by_offer_config_and_user";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {gtmRotatingPhoneNumbersReveal} from "../../tracking/google_tag_manager/gtm_rotating_phone_numbers";
import {hotlineTelNumber} from "../../types/HotlineTelNumber";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";
import {ClipPhoneButton} from "../ClipPhoneButton";

interface IProps {
    isOpen: boolean;
    closeModal: () => void;
    vendor: {
        id: number;
        name: string;
        logo: {
            v_log_120x90: string;
        } | null;
        logo_url: string | null;
    };
    offer: {
        id: number;
        name: string;
        configuration: {
            personal_data_processor_name?: string | null;
            personal_data_processor_url?: string | null;
            privacy_policy_url?: string | null;
        };
        currency: Currency;
    };

    propertyPrice?: number | null;
    propertyId?: number;
    phoneNumber?: string;
    trackUser: () => void;
}

export const CallModal = (props: IProps) => {
    const {isOpen, closeModal, vendor, offer, propertyPrice, propertyId, phoneNumber, trackUser} = props;
    const isHotlineTelNumber = phoneNumber === hotlineTelNumber;
    const currencyUnit = offer.currency === Currency.EURO ? "eur" : "zł";

    const shouldShowPrice = useShouldShowPriceByOfferConfigAndUser({
        vendorId: vendor.id
    });

    const buttonCategory = propertyId ? "property_page" : "investment_page";

    const handleShowPhoneNumber = () => {
        gtmRotatingPhoneNumbersReveal("modal");

        trackAmplitudeButtonClick({
            buttonName: "offer_show_number",
            buttonCategory,
            itemId: offer.id,
            propertyId
        });
    };

    const handlePhoneNumberClick = (clickedPhoneNumber: string) => {
        trackUser();

        trackAmplitudeButtonClick({
            buttonName: "offer_call_investor",
            buttonCategory,
            itemId: offer.id,
            propertyId,
            buttonLink: clickedPhoneNumber
        });
    };

    return (
        <ModalCore isOpen={isOpen} overlayStyle={modalOverlay} contentStyle={modalContent} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PHONE_MODAL}>
            <CloseIcon className={closeIcon} size="2" wrapperSize="3.2" wrapperColor="white" onClick={closeModal} />
            <div className={contentWrapper}>
                <ApplicationVendorInfo
                    vendorLogo={getThumbnailLink(vendor.logo_url, 120, 90) ?? (vendor.logo && vendor.logo.v_log_120x90)}
                    vendorName={vendor.name}
                    headerText={offer.name}
                />

                <ClipPhoneButton
                    fallbackNumber={phoneNumber}
                    onClickPhoneNumber={handlePhoneNumberClick}
                    onShowPhoneNumber={handleShowPhoneNumber}
                    propertyId={propertyId}
                    className={callButton}
                    fetchOnMount={isOpen}
                    useHotlineNumber={isHotlineTelNumber}
                />

                {shouldShowPrice && propertyPrice && (
                    <>
                        <Text as="span" variant="body_copy_2" className={css({mb: 1})}>
                            Cena tej nieruchomości:
                        </Text>
                        <Text as="span" variant="body_copy_0" align="center" className={css({mb: 2})}>
                            <Highlight strong>{priceFormat(propertyPrice as number, {unit: currencyUnit})}</Highlight>
                        </Text>
                    </>
                )}

                <ApplicationFormRodoInfo
                    vendor={vendor as IVendorDetailApplication}
                    offerPrivacyPolicyUrl={offer?.configuration.privacy_policy_url}
                    offerPersonalDataProcessorName={offer?.configuration.personal_data_processor_name as string}
                    offerPersonalDataProcessorUrl={offer?.configuration.personal_data_processor_url}
                />
            </div>
        </ModalCore>
    );
};

const modalOverlay = {
    //z-index is greater by 1 than the z-index of the gallery on offer/property view
    zIndex: 9001
};

const modalContent = {
    inset: "auto 1.2rem 6.4rem 1.2rem",
    overflow: "visible"
};

const closeIcon = css({
    position: "absolute",
    zIndex: 9002,
    top: "-28px",
    right: "-28px"
});

const contentWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
});

const callButton = css({
    mb: 2,
    width: "75%",
    maxWidth: "360px",
    textAlign: "center"
});
import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {ModalCore} from "@pg-design/modal-module";
import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {Currency} from "@pg-rp/common-types";

import {ApplicationFormRodoInfo} from "../../application/components/ApplicationFormRodoInfo";
import {ApplicationVendorInfo} from "../../application/components/ApplicationVendorInfo";
import {useShouldShowPriceByOfferConfigAndUser} from "../../hooks/use_should_show_price_by_offer_config_and_user";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {gtmRotatingPhoneNumbersReveal} from "../../tracking/google_tag_manager/gtm_rotating_phone_numbers";
import {hotlineTelNumber} from "../../types/HotlineTelNumber";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";
import {ClipPhoneButton} from "../ClipPhoneButton";

interface IProps {
    isOpen: boolean;
    closeModal: () => void;
    vendor: {
        id: number;
        name: string;
        logo: {
            v_log_120x90: string;
        } | null;
        logo_url: string | null;
    };
    offer: {
        id: number;
        name: string;
        configuration: {
            personal_data_processor_name?: string | null;
            personal_data_processor_url?: string | null;
            privacy_policy_url?: string | null;
        };
        currency: Currency;
    };

    propertyPrice?: number | null;
    propertyId?: number;
    phoneNumber?: string;
    trackUser: () => void;
}

export const CallModal = (props: IProps) => {
    const {isOpen, closeModal, vendor, offer, propertyPrice, propertyId, phoneNumber, trackUser} = props;
    const isHotlineTelNumber = phoneNumber === hotlineTelNumber;
    const currencyUnit = offer.currency === Currency.EURO ? "eur" : "zł";

    const shouldShowPrice = useShouldShowPriceByOfferConfigAndUser({
        vendorId: vendor.id
    });

    const buttonCategory = propertyId ? "property_page" : "investment_page";

    const handleShowPhoneNumber = () => {
        gtmRotatingPhoneNumbersReveal("modal");

        trackAmplitudeButtonClick({
            buttonName: "offer_show_number",
            buttonCategory,
            itemId: offer.id,
            propertyId
        });
    };

    const handlePhoneNumberClick = (clickedPhoneNumber: string) => {
        trackUser();

        trackAmplitudeButtonClick({
            buttonName: "offer_call_investor",
            buttonCategory,
            itemId: offer.id,
            propertyId,
            buttonLink: clickedPhoneNumber
        });
    };

    return (
        <ModalCore isOpen={isOpen} overlayStyle={modalOverlay} contentStyle={modalContent} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PHONE_MODAL}>
            <CloseIcon className={closeIcon} size="2" wrapperSize="3.2" wrapperColor="white" onClick={closeModal} />
            <div className={contentWrapper}>
                <ApplicationVendorInfo
                    vendorLogo={getThumbnailLink(vendor.logo_url, 120, 90) ?? (vendor.logo && vendor.logo.v_log_120x90)}
                    vendorName={vendor.name}
                    headerText={offer.name}
                />

                <ClipPhoneButton
                    fallbackNumber={phoneNumber}
                    onClickPhoneNumber={handlePhoneNumberClick}
                    onShowPhoneNumber={handleShowPhoneNumber}
                    propertyId={propertyId}
                    className={callButton}
                    fetchOnMount={isOpen}
                    useHotlineNumber={isHotlineTelNumber}
                />

                {shouldShowPrice && propertyPrice && (
                    <>
                        <Text as="span" variant="body_copy_2" className={css({mb: 1})}>
                            Cena tej nieruchomości:
                        </Text>
                        <Text as="span" variant="body_copy_0" align="center" className={css({mb: 2})}>
                            <Highlight strong>{priceFormat(propertyPrice as number, {unit: currencyUnit})}</Highlight>
                        </Text>
                    </>
                )}

                <ApplicationFormRodoInfo
                    vendor={vendor as IVendorDetailApplication}
                    offerPrivacyPolicyUrl={offer?.configuration.privacy_policy_url}
                    offerPersonalDataProcessorName={offer?.configuration.personal_data_processor_name as string}
                    offerPersonalDataProcessorUrl={offer?.configuration.personal_data_processor_url}
                />
            </div>
        </ModalCore>
    );
};

const modalOverlay = {
    //z-index is greater by 1 than the z-index of the gallery on offer/property view
    zIndex: 9001
};

const modalContent = {
    inset: "auto 1.2rem 6.4rem 1.2rem",
    overflow: "visible"
};

const closeIcon = css({
    position: "absolute",
    zIndex: 9002,
    top: "-28px",
    right: "-28px"
});

const contentWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
});

const callButton = css({
    mb: 2,
    width: "75%",
    maxWidth: "360px",
    textAlign: "center"
});
